import React, { useState, useEffect } from 'react'
import { useSnapshot } from 'valtio'
import { useResponsive } from 'ahooks'
import { Space, Divider } from 'antd'
import { SyncOutlined } from '@ant-design/icons'

import { configState } from '@/store'
import styles from './QuickHints.module.less'
import PromptModal from '@/components/PromptEditor/modal'

function getHintTexts(data = [], number: number) {
  if (data.length > 0) {
    // 克隆原始数组，以免修改原始数组
    const shuffledArray = [...data]
    // 打乱数组顺序
    shuffledArray.sort(() => 0.5 - Math.random())
    // 返回不重复的随机数
    return shuffledArray.slice(0, number)
  } else {
    return []
  }
}

const QuickHints = () => {
  const { bannerData } = useSnapshot(configState)
  const { selectTopic, reloadBtn, topicList } = bannerData || {}
  // const { apps } = useSnapshot(configState)
  const [hints, setHints] = useState<any[]>([])
  const [openModal, setOpenModal] = useState(false)
  const [editItem, setEditItem] = useState({})
  const responsive = useResponsive()

  useEffect(() => {
    setHints(getHintTexts(topicList || [], 4))
  }, [topicList])

  return (
    <>
      {responsive.md ? (
        <div className={styles.quick}>
          <div className={styles.title}>
            <span>{selectTopic || '选择以下话题，快速与我对话：'}</span>
            {reloadBtn && (
              <span
                className="cursor-pointer"
                onClick={() => {
                  setHints(getHintTexts(topicList || [], 4))
                }}
              >
                <SyncOutlined className="mr-[5px]" />
                换一批
              </span>
            )}
          </div>
          <div className={styles.list}>
            {hints.length > 0 &&
              hints.map((item, index) => (
                <div
                  className={styles.item}
                  key={index}
                  onClick={() => {
                    setEditItem(item)
                    setOpenModal(true)
                  }}
                >
                  <Space size={8} direction="vertical">
                    <div className="text-slate-900 font-[500]">
                      {item?.title}
                    </div>
                    <div
                      style={{
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                      }}
                      className="text-xs text-[#77797B]"
                    >
                      {item?.real_prompt}
                    </div>
                  </Space>
                </div>
              ))}
          </div>
        </div>
      ) : (
        <div className={styles.mobileQuick}>
          <div className={styles.title}>
            <span>{selectTopic || '选择以下话题，快速与我对话：'}</span>
            {reloadBtn && (
              <span
                className="cursor-pointer"
                onClick={() => {
                  setHints(getHintTexts(topicList || [], 4))
                }}
              >
                <SyncOutlined className="mr-[5px]" />
                换一批
              </span>
            )}
          </div>
          <div className={styles.list}>
            {hints.length > 0 &&
              hints.map((item, index) => (
                <React.Fragment key={index}>
                  <div
                    className={styles.item}
                    onClick={() => {
                      setEditItem(item)
                      setOpenModal(true)
                    }}
                  >
                    <div
                      style={{
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 1,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                      }}
                      className="text-slate-700"
                    >
                      {item?.real_prompt}
                    </div>
                  </div>
                  {index !== hints.length - 1 && (
                    <Divider className="mt-0 mb-0" />
                  )}
                </React.Fragment>
              ))}
          </div>
        </div>
      )}
      <PromptModal
        open={openModal}
        onCancel={() => {
          setOpenModal(false)
        }}
        onOK={() => {
          setOpenModal(false)
        }}
        data={editItem}
      />
    </>
  )
}

export default QuickHints
